// 🔑 SUBMIT AN APPLICATION'S TABS (Jesse's approval change 1, 2026-10-28): one component, styled per width
// (loSubmission.css) — a tab bar on desktop (full-width rule, padded hit areas, blue text and a 3px blue underline on
// the active tab, grey inactive, a hover state, counts in a small pill), a segmented control on a phone (one rounded
// light container, three equal segments, the active one white with blue text). Labels never wrap.
import React from 'react';
import './loSubmission.css';

export default function SubmissionTabs({ tab, onChange, drafts, submitted }) {
  const tabs = [
    { key: 'new', label: 'New' },
    { key: 'drafts', label: 'Drafts', count: drafts },
    { key: 'submitted', label: 'Submitted', count: submitted },
  ];
  return (
    <div className="lo-tabs" role="tablist" aria-label="Submit an Application" data-testid="lo-tabs">
      {tabs.map((t) => (
        <button key={t.key} type="button" role="tab" aria-selected={tab === t.key ? 'true' : 'false'}
          data-testid={`lo-tab-${t.key}`} className="lo-tab" onClick={() => onChange(t.key)}>
          <span>{t.label}</span>
          {t.count != null && <span className="lo-tab-count">{t.count}</span>}
        </button>
      ))}
    </div>
  );
}
